<template>
  <div class="commentApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" :style="'min-height:'+curHeight+'px'">
    <div class="comment">
      <h2>Evaluation Center</h2>
      <ul class="lyan">
        <div v-if="setAllComtent.length <= 0" style="text-align:center;padding:60px 0">No messages yet~</div>
        <li v-for="(item,i) in setAllComtent">
          <div class="user">
            <span>{{item.username}}</span>
            <font>{{item.createtime}}</font>
          </div>
          <p>{{item.content}}</p>
          <div class="qkan">期刊：{{item.title}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setAllComtent:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getAllComtent();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getAllComtent:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/allComtent',
          dataType:'json',
          success:function(data){
            that.setAllComtent = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .commentApp .el-message-box{
    width:30%
  }
  .commentApp{
    max-width:750px;
    margin:0 auto;
    background:#fff;
    padding-bottom:8px
  }
  .commentApp .comment{
    width:100%;
    margin:0 auto
  }

  .commentApp .comment h2{
    width:96%;
    margin:0 auto;
    position:relative;
    font-size:16px;
    padding:8px 0 8px 4%;
    background: #F1F2F5;
  }
  .commentApp .comment h2:after{
    content:'';
    width: 4px;
    height: 14px;
    background: #000;
    position:absolute;
    left:10px;
    top:13px;
    border-radius: 3px;
  }

  .commentApp .comment .lyan{
    width: 94%;
    margin: 0 auto;
  }
  .commentApp .comment .lyan li{
    width:100%;
    margin:15px auto 0 auto;
    border-bottom:solid 1px #F1F2F5;
    padding-bottom:15px
  }
  .commentApp .comment .lyan li .user span{
    font-weight:bold;
    font-size:16px;
    color:#000
  }
  .commentApp .comment .lyan li .user font{
    float:right;
    font-size:14px;
    color:#666
  }
  .commentApp .comment .lyan li p{
    font-size:15px;
    color:#333;
    padding-top:8px;
    line-height:22px
  }
  .commentApp .comment .lyan li .qkan{
    color:#0052D9;
    font-size:12px;
    padding-top:8px
  }
</style>